module.exports = __webpack_public_path__ + "img/kx5600-5.a1696c0c.png";